import React, { useState } from 'react'
import CurrencyInput from 'tennders-common/form/components/new-inputs/CurrencyInput'
import useUpdateBookRate from 'tennders-market/common/hooks/useUpdateBookRate'
import GCurrency from 'tennders-market/common/components/element/GCurrency'
import { GButton } from 'tennders-common/form/components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

const AgreedPriceField = ({ agreedPrice, setTransaction, transaction }) => {
  const [priceEditable, setPriceEditable] = useState(false)
  const { setInputPrice, updatePrice, inputPrice, saving } = useUpdateBookRate({ transaction, setEditable: setPriceEditable })

  const saveNewPrice = async () => {
    await updatePrice('truck')
    setTransaction(prev => ({
      ...prev,
      matchedTruck: {
        ...prev.matchedTruck,
        bookRate: inputPrice,
        totalPrice: inputPrice
      }
    }))
  }

  if (!priceEditable) {
    return (
      <div onClick={() => setPriceEditable(true)} className="d-flex row w-100 cursor-pointer">
        <span>
          <b>
            {agreedPrice ? GCurrency({ value: agreedPrice }) : '-'}
          </b>
        </span>
        {agreedPrice !== null && agreedPrice !== undefined ? (
          <img className="ml-2" src="/img/icon-edit.svg" alt="edit" width="18" height="18"></img>
        ) : null}
      </div>
    )
  }

  return (
    <div className="pos-rel">
      <CurrencyInput
        className="form-input smaller w-auto"
        value={inputPrice}
        onSet={setInputPrice}
      />
      <GButton
        className="btn standard-btn text-12"
        style={{ top: 5, right: 26, position: 'absolute', padding: 4, borderRadius: 3 }}
        onClick={saveNewPrice}
      >
        {saving ? <FontAwesomeIcon icon={faSpinner} spin /> : 'Save'}
      </GButton>
    </div>
  )
}

export default React.memo(AgreedPriceField)
